(() => {
  angular
    .module('gm.common.filters')
    .filter('gmyFormatTimeTo', gmyFormatTimeTo);

  function gmyFormatTimeTo(
    $window,
    gettextCatalog
  ) {
    'ngInject';

    const formatRecurring = (input) => {
      const days = gettextCatalog.getString('days');
      const hours = gettextCatalog.getString('hours');
      const minutes = gettextCatalog.getString('minutes');
      const destination = $window.moment.duration(input, 's');
      let template;
      if (input > 86400) {
        template = `d [${days}] h [${hours}] m [${minutes}]`;
      } else if (input > 3600) {
        template = `h [${hours}] m [${minutes}]`;
      } else {
        template = `m [${minutes}]`;
      }
      const period = destination.format(template);

      return period;
    };
    formatRecurring.$stateful = true;

    return formatRecurring;
  }
})();
